/**
 * Tutor certification form section.
 * 360 Learning certificate upload plus attestation number and obtention date.
 */
import * as React from 'react';
import { Award } from 'lucide-react';
import { Input } from '@/components/forms/Input';
import { DatePicker } from '@/components/forms/DatePicker';
import { FileDropzone } from '@/components/common/FileDropzone';
import { TUTOR_CERT_UPLOAD_CONFIG } from '@/components/tutors/tutor-configs';
import { defaultUpload, fileNameFromUrl } from '@/components/tutors/remote/tutor-form-utils';

/** Props for {@link TutorCertificationSection}. */
type Props = Readonly<{
  formData: Record<string, any>;
  onChange: (key: string, value: any) => void;
  onFileSelect?: (key: string, file: File | null) => void;
}>;

/** Tutor certification form section. */
export function TutorCertificationSection({ formData, onChange, onFileSelect }: Props) {
  return (
    <div className="form-section">
      <h4 className="form-section-title">
        <Award className="w-4 h-4" />
        Certifications
      </h4>
      <div className="space-y-4">
        <FileDropzone
          label="Certificat 360 Learning"
          value={formData.certDocumentLink ?? ''}
          onChange={(url) => {
            onChange('certDocumentLink', url);
            if (url) {
              onChange('certDocumentName', fileNameFromUrl(url));
              onChange('certUploadDate', new Date().toISOString().slice(0, 10));
            }
          }}
          onFileSelect={onFileSelect ? (file) => onFileSelect('certFile', file) : undefined}
          uploadFn={onFileSelect ? undefined : defaultUpload}
          accept={TUTOR_CERT_UPLOAD_CONFIG.accept}
          maxSize={TUTOR_CERT_UPLOAD_CONFIG.maxSize}
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <Input
            label="Numéro d'attestation"
            value={formData.attestationNumber ?? ''}
            onChange={(e) => onChange('attestationNumber', e.target.value)}
            inputSize="sm"
            placeholder="Ex: CERT-2026-001"
          />
          <DatePicker
            label="Date d'obtention"
            value={formData.obtentionDate ?? ''}
            onChange={(value) => onChange('obtentionDate', value)}
            inputSize="sm"
            placeholder="JJ/MM/AAAA"
          />
        </div>
      </div>
    </div>
  );
}
